import jsPDF from "jspdf";

const fmt = (n) => `EUR ${(n || 0).toFixed(2)}`;

export function generateInvoicePdf(inv, { print = false } = {}) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const left = 20;
  let y = 24;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(194, 65, 39);
  doc.text("Il Mio Locale", left, y);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(90, 90, 84);
  y += 6;
  doc.text("Ristorante · P.IVA _______________", left, y);

  doc.setDrawColor(220);
  doc.line(left, y + 6, 190, y + 6);

  y += 18;
  doc.setTextColor(26, 26, 26);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(`Fattura n. ${inv.number}`, left, y);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`Data: ${inv.date}`, 150, y);

  y += 10;
  doc.text(`Cliente: ${inv.client || "-"}`, left, y);
  doc.text(`Stato: ${inv.status}`, 150, y);

  y += 14;
  doc.setFillColor(243, 243, 239);
  doc.rect(left, y - 5, 170, 9, "F");
  doc.setFont("helvetica", "bold");
  doc.text("Descrizione", left + 2, y);
  doc.text("Importo", 175, y, { align: "right" });
  doc.setFont("helvetica", "normal");

  y += 10;
  doc.text(`Imponibile`, left + 2, y);
  doc.text(fmt(inv.subtotal), 175, y, { align: "right" });
  y += 8;
  doc.text(`IVA (${inv.tax_rate}%)`, left + 2, y);
  doc.text(fmt(inv.tax), 175, y, { align: "right" });

  y += 6;
  doc.line(left, y, 190, y);
  y += 8;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("TOTALE", left + 2, y);
  doc.text(fmt(inv.total), 175, y, { align: "right" });

  y += 24;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(140, 140, 134);
  doc.text("Grazie per la vostra fiducia — Il Mio Locale", left, 280);

  if (print) {
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");
  } else {
    doc.save(`Fattura_${inv.number.replace(/\//g, "-")}.pdf`);
  }
}
